import { render, staticRenderFns } from "./BankListFreeAutoWithdrawal.vue?vue&type=template&id=a9b60dc4&lang=pug"
import script from "./BankListFreeAutoWithdrawal.vue?vue&type=script&lang=js"
export * from "./BankListFreeAutoWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports